const en = {
  'filters.payoff.fortyProviders': '40 providers',
  'filters.payoff.lastUpdated': 'Interest rates last updated on {date}',
  'filters.mortgageType': 'Mortgage type',
  'filters.mortgageTerm': 'Fixed-interest period',
  'filters.mortgageTerm.variable': 'Variable',
  'filters.mortgageTerm.year': '{int} year',
  'filters.interestTariff': 'Interest rate',
  'filters.interestTariff.tooltip':
    'You can take out a mortgage with or without National Mortgage Guarantee (NHG). This is a guarantee on mortgages for homes up to {nhg} or {nhgEnergy} when you spend this extra amount entirely on energy-saving measures. With an NHG mortgage, homeowners run less risk as a homeowner and you benefit from an interest rate discount. If the purchase price or market value of the home is higher than the stated amounts mentioned, you will have a mortgage without NHG. The amount of the interest rate is determined by each provider based on the ratio to the market value of the home. For example, if the mortgage is 60% of the market value of the home, then interest rate is lower than for a mortgage that is 100% of the market value of the home. Our mortgage advisors will find the best mortgage interest rate for your personal situation.',
  'filters.interestTariff.tooltip.nhgLink':
    '<a href="https://www.hypotheker.nl/begrippenlijst/huis-kopen/nationale-hypotheek-garantie/" class="text-white underline">National Mortgage Guarantee</a>',
  'filters.interestTariff.tooltip.marketValueLink':
    '<a href="https://www.hypotheker.nl/begrippenlijst/huis-kopen/marktwaarde/" class="text-white underline">market value</a>',
  'filters.buildingType': 'Type construction',
  'filters.buildingType.existing': 'Existing house',
  'filters.buildingType.new': 'New construction',
  'filters.energyLabel': 'Energy label',
  'filters.interestRate.applyFilters': 'Filter resultaten',
  'filters.showFilters': 'Filter',
  'header.mortgageProviders': 'Provider',
  'header.mortgageProduct': 'Mortgage type',
  'header.interest': 'Interest rate',
  'item.calculateMonthlyCosts': 'Calculate your monthly repayment',
  'items.button.showAll': 'Show all 40 results'
};
export default en;
